/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import { NotificationSeverity, NotificationSource, type UINotification } from '@poweralpha/common';
import type { InfiniteData } from '@tanstack/react-query';
import type { UINotificationsQueryResult } from '../types';

export type PopperTabKey = 'all' | 'unread' | 'errors' | 'agent';

export interface PopperTab {
  key: PopperTabKey;
  label: string;
  /** Unread count shown as a pill; omitted when zero. */
  count?: number;
  notifications: Array<UINotification>;
}

// The popper is a preview of the latest notifications. "Unread" uses the
// server's full unread list; the other tabs filter what is already loaded.
export const getPopperTabs = (
  data: InfiniteData<UINotificationsQueryResult> | undefined,
): Array<PopperTab> => {
  const rows = data?.pages.flatMap((page) => page.rows) ?? [];
  const unread = data?.pages.at(0)?.unread ?? [];
  const isError = ({ severity }: UINotification) => severity === NotificationSeverity.ERROR;
  const unreadErrors = unread.filter(isError).length;

  return [
    { key: 'all', label: 'All', notifications: rows },
    { key: 'unread', label: 'Unread', count: unread.length || undefined, notifications: unread },
    {
      key: 'errors',
      label: 'Errors',
      count: unreadErrors || undefined,
      notifications: rows.filter(isError),
    },
    {
      key: 'agent',
      label: 'Agent',
      notifications: rows.filter(({ source }) => source === NotificationSource.AGENT),
    },
  ];
};
